export default "__VITE_ASSET__07e8f05b__"